import { useAuth } from '@iamexperiences/feature-auth';
import { ITelemetry, useTelemetry } from '@iamexperiences/ecos-telemetry';
import { useQuery } from 'react-query';

import { HttpRequestError } from '../../shared/HttpRequestError';
import { settingsManager } from '../../shared/settings';
import { getRequestBody } from '../utilities/getRequestBody';

export const useGetPolicyFileDataAuthenticated = (agreementId: string, policyFileId: string) => {
  const telemetry = useTelemetry();
  const { auth } = useAuth();

  const query = useQuery({
    queryKey: [{ scope: 'policyfiles-authenticated', agreementId, policyFileId }],
    queryFn: async ({ queryKey }) => {
      const clientId = settingsManager.getRequired('clientId');
      const token = await auth.acquireToken({ scopes: [clientId] });
      return getPolicyFileDataQueryFn(queryKey[0].agreementId, queryKey[0].policyFileId, token, telemetry);
    },
    staleTime: Infinity,
  });

  return query;
};

export const useGetPolicyFileDataUnauthenticated = (agreementId: string, policyFileId: string) => {
  const telemetry = useTelemetry();

  const query = useQuery({
    queryKey: [{ scope: 'policyfiles-unauthenticated', agreementId, policyFileId }],
    queryFn: async ({ queryKey }) => {
      const { accessToken } = getRequestBody();
      return getPolicyFileDataQueryFn(queryKey[0].agreementId, queryKey[0].policyFileId, accessToken, telemetry);
    },
    staleTime: Infinity,
  });

  return query;
};

async function getPolicyFileDataQueryFn(
  agreementId: string,
  policyFileId: string,
  token: string,
  telemetry: ITelemetry,
) {
  const url = `${settingsManager.get(
    'myAccountBackendUrl',
  )}/api/termsofuse/agreements/${agreementId}/policyfiles/${policyFileId}/data`;
  const response = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });

  if (!response.ok) {
    const error = new HttpRequestError(response.status, response.statusText);
    telemetry.error('Error getting policyfile', error);

    throw error;
  }

  const data = await response.json();

  return data;
}
